import Parsley from 'parsleyjs'

Parsley.addMessages('hu', {
  defaultMessage: 'Érvénytelen érték',
  type: {
    email: 'Érvénytelen email',
    url: 'Érvénytelen url',
    number: 'Érvénytelen szám',
    integer: 'Egész szám megadása kötelező',
    digits: 'Csak számjegyeket tartalmazhat',
    alphanum: 'Invalid alphanumeric value.'
  },
  notblank: 'Kitöltendő',
  required: 'Kötelező mező',
  pattern: 'Érvénytelen értek',
  min: 'Legalább %s kell, hogy legyen',
  max: 'Legfejlebb %s lehet',
  range: '%s és %s közötti érték megadása kötelező',
  minlength: 'Legalább %s karakter megadása kötelező',
  maxlength: 'Legfeljebb %s karakter lehet',
  length: '%s és %s karakter között lehet',
  mincheck: 'Legalább %s lehetőség kiválasztása kötelező',
  maxcheck: 'Legfeljebb %s lehetőség választható',
  check: '%s és %s közötti lehetőség kiválasztandó',
  equalto: 'Nem egyező érték'
})



// WEBPACK FOOTER //
// ./src/parsley-hu.js